import axios from "axios";
const CONTROLLER_PATH = "CustomerCompany";
class CompanyService {
    //CREATE
    create(formData) {
        return axios
            .post(CONTROLLER_PATH, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            })
            .then((response) => response.data);
    }
    addNote(companyId, text) {
        return axios.put(CONTROLLER_PATH + "/" + companyId + "/addNote", { text: text }).then((response) => response.data);
    }

    sendwelcomesmstocompanycontactpersons(urlParameters) {
        return axios.get(CONTROLLER_PATH + "/sendwelcomesmstocompanycontactpersons/", {params:urlParameters}).then(() => {});
    }
    //READ
    get(id, urlParameters, requestId) {
        return axios.get(CONTROLLER_PATH + (id ? "/" + id : ""), { params: urlParameters, requestId: requestId }).then((response) => ({
            data: response.data,
            requestId: response.config.requestId,
        }));
    }

    getlist() {
        return axios.get(CONTROLLER_PATH + "/getlist").then((response) => response.data);
    }

    getbankaccounttypes() {
        return axios.get(CONTROLLER_PATH + "/GetBankAccountTypes").then((response) => response.data);
    }

    getCompanyStatuses() {
        return axios.get(CONTROLLER_PATH + "/getCompanyStatuses").then((response) => ({
            data: response.data,
        }));
    }

    getCompanyContactDesignations(){
        return axios.get(CONTROLLER_PATH + "/getCustomerContactDesignations").then((response) => ({
            data: response.data,
        }));
    }

    getCompanyPaymentPreferences(){
        return axios.get(CONTROLLER_PATH + "/getCompanyPaymentPreferences").then((response) => (
             response.data
        ));
    }

    //UPDATE
    update(id, formData) {
        //formData.append('_method', 'PUT');
        return axios
            .put(CONTROLLER_PATH + "/" + id, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            })
            .then((response) => response.data);
    }

    //DELETE
    delete(id) {
        return axios.delete(CONTROLLER_PATH + "/" + id).then(() => {});
    }

    //
    addcontact(companyid, customercompanycontact) {
        return axios.put(CONTROLLER_PATH + "/" + companyid + "/AddContact", customercompanycontact).then((response) => response.data);
    }
    updatecontact(companyid, customercompanycontact) {
        return axios.put(CONTROLLER_PATH + "/" + companyid + "/UpdateContact", customercompanycontact).then((response) => response.data);
    }
    deletecontact(companyid,customercompanycontactid) {
        return axios.delete(CONTROLLER_PATH + "/" + companyid + "/DeleteContact/" + customercompanycontactid).then(() => {});
    }
}

export default new CompanyService();
